import { spCandidateHistoryAchievementsLocs } from './achievements/achievements.locs';
import { spCandidateAdditionalAgreementsLocs } from './additional-agreements/additional-agreements.locs';
import { spCandidateBenefitsLocs } from './benefits/benefits.locs';
import { spCandidateBadgingLocs } from './candidate-badging/candidate-badging.locs';
import { spCandidateCECurrentLocs } from './continuing-education/ce-current/ce-current.locs';
import { spCandidateCEPastLocs } from './continuing-education/ce-past/ce-past.locs';
import { spCandidateCeProgressLocs } from './continuing-education/ce-progress/ce-progress.locs';
import { spCandidateCELocs } from './continuing-education/continuing-education.locs';
import { spCandidateLatestAgreementLocs } from './credential-agreements/credential-agreements.locs';
import { spCandidateLatestAgreementModalLocs } from './credential-agreements/latest-agreement-modal/latest-agreement-modal.locs';
import { spCandidateHistoryCredentialRequestsLocs } from './credential-requests/credential-requests.locs';
import { spCandidateHistoryCompleteRebuildRequestLocs } from './credential-requests/modals/complete-rebuild-request-modal/complete-rebuild-request-modal.locs';
import { spCandidateHistoryGrantCredentialLocs } from './credential-requests/modals/grant-credential-modal/grant-credential-modal.locs';
import { spCandidateHistoryManualChangeCredentialLocs } from './credential-requests/modals/manual-change-credential-modal/manual-change-credential-modal.locs';
import { spCandidateHistoryRebuildRequestModalLocs } from './credential-requests/modals/rebuild-request-modal/rebuild-request-modal.locs';
import { spCandidateHistoryRemoveChangeModalLocs } from './credential-requests/modals/remove-change-modal/remove-change-modal.locs';
import { spCredentialDetailsLocs } from './credentials/credential-details/credential-details.locs';
import { spCandidateHistoryCredentialLocs } from './credentials/credentials.locs';
import { spCandidateHistoryCreqEditLocs } from './creq-details/creq-edit/creq-edit.locs';
import { spCandidateHistoryEnrollmentLocs } from './enrollment/enrollment.locs';
import { examEventsLocs } from './exam-events/exam-events.locs';
import { spCandidateHistoryExamVouchersDetailsLocs } from './exam-vouchers/exam-voucher-details/exam-voucher-details.locs';
import { spCandidateHistoryExamVouchersLocs } from './exam-vouchers/exam-vouchers.locs';
import { spCandidateHistoryExternalCertLocs } from './external-certs/external-certs.locs';
import { spCandidateHistoryExternalExamLocs } from './external-exam/external-exam.locs';
import { spCandidateFulfillmentQueueLocs } from './fulfillment/fulfillment-queue/fulfillment-queue.locs';
import { spCandidateHistoryFulfillmentReleaseLocs } from './fulfillment/fulfillment-release/fulfillment-release.locs';
import { spCandidateHistoryItsScoreReportsLocs } from './its-score-reports/its-score-reports.locs';
import { spCandidateHistoryLabLocs } from './labs/labs.locs';
import { spCandidateHistoryParticipationLocs } from './participation/participation.locs';
import { spCandidateHistoryTrainingLocs } from './training/training.locs';

export const spCandidateHistoryModuleLocs = {
	...spCandidateAdditionalAgreementsLocs,
	...spCandidateBenefitsLocs,
	...spCandidateBadgingLocs,
	...spCandidateCeProgressLocs,
	...spCandidateCELocs,
	...spCandidateCECurrentLocs,
	...spCandidateCEPastLocs,
	...spCandidateHistoryAchievementsLocs,
	...spCandidateHistoryEnrollmentLocs,
	...examEventsLocs,
	...spCredentialDetailsLocs,
	...spCandidateHistoryExternalCertLocs,
	...spCandidateHistoryExternalExamLocs,
	...spCandidateHistoryExamVouchersDetailsLocs,
	...spCandidateHistoryExamVouchersLocs,
	...spCandidateHistoryLabLocs,
	...spCandidateHistoryParticipationLocs,
	...spCandidateHistoryTrainingLocs,
	...spCandidateHistoryCompleteRebuildRequestLocs,
	...spCandidateHistoryGrantCredentialLocs,
	...spCandidateHistoryManualChangeCredentialLocs,
	...spCandidateHistoryRebuildRequestModalLocs,
	...spCandidateHistoryRemoveChangeModalLocs,
	...spCandidateHistoryCredentialRequestsLocs,
	...spCandidateLatestAgreementModalLocs,
	...spCandidateLatestAgreementLocs,
	...spCandidateFulfillmentQueueLocs,
	...spCandidateHistoryFulfillmentReleaseLocs,
	...spCandidateHistoryCredentialLocs,
	...spCandidateHistoryItsScoreReportsLocs,
	...spCandidateHistoryCreqEditLocs,
};
